import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiservice from '../services/apiservices'
import { headerDataUpdate,subHeaderDataUpdate, logoutRequest, resetPageReady } from '../../../redux/user'
import * as Constants from '../../../common/constants'
import '../static/css/resetPassword.css'

class PasswordReset extends Component {
    constructor(props) {
        super(props)
        this.state = {
            bodyHeight: "0px",
            errorMessage: "",
            errorVisibility: "none",
        }
        this.oldPasswordComp = null
        this.newPasswordComp = null
        this.retypedPasswordComp = null
    }

    componentWillMount() {
         this.props.dispatch(resetPageReady(true))
        this.props.dispatch(headerDataUpdate(Constants.RESET_PASSWORD))        
        this.props.dispatch(subHeaderDataUpdate())
        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()
    }

    updateDimensions = () => {
        if (window.innerWidth <= 767) {
            this.setState({
                bodyHeight: (window.innerHeight - 150) + "px",
            })
        } else {
            this.setState({
                bodyHeight: (window.innerHeight - 80) + "px",
            })
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    resetErrorMessage = () => {
        this.setState({
            errorMessage: "",
            errorVisibility: "none",
        })
    }

    resetPasswordCall = () => {
        let oldPassword = this.oldPasswordComp.value.trim()
        let newPassword = this.newPasswordComp.value.trim()
        let retypedPassword = this.retypedPasswordComp.value.trim()

        if(oldPassword !== "" && newPassword !== "" && retypedPassword !== "") {
            if (newPassword === retypedPassword) {
                this.props.dispatch(resetPageReady(false))
                let data = {
                    "current_password": oldPassword,
                    "new_password": newPassword,
                }
                console.log("get userId value " + this.props.user.id)
                apiservice.resetPassword(data, this.props.user.id)
                    .then(resetData => {
                        if (resetData.status === "SUCCESS") {
                            this.props.history.push("/dashboard")
                            this.props.dispatch(resetPageReady(true))
                            this.props.dispatch(logoutRequest(false))
                        } else {
                            this.props.dispatch(resetPageReady(true))
                            console.error("Wrong password response")
                            this.setState({
                                errorMessage: resetData.reason,
                                errorVisibility: "block",
                            })
                        }
                    })
                    .catch(err => {
                        this.props.dispatch(resetPageReady(true))
                        this.setState({
                            errorMessage: "Something went wrong, Not able to update your new password",
                            errorVisibility: "block",
                        })
                        console.error("Error message: ", err)
                    })
            } else {
                 this.props.dispatch(resetPageReady(true))
                this.setState({
                    errorMessage: "New Password and Retyped New Passwords are not matching",
                    errorVisibility: "block",
                })
            }
        } else {
             this.props.dispatch(resetPageReady(true))
            this.setState({
                errorMessage: "Enter password data and try again",
                errorVisibility: "block",
            })
        }
    }

    render() {
        return (

            <section className="content">
                    <div className="row">
                    <Dialog ref={el => this.dialog = el} />
            <div className="col-md-5 col-sm-9 col-xs-12" style={{ height: this.state.bodyHeight }}>
            
                <div className="register-box-body reset-password">
                    <p className="login-box-msg header-text">Reset your Password</p>

                    <form style={{ marginTop: "20px" }}>
                        <div className="form-group has-feedback">
                            <input type="password" className="form-control"
                                placeholder="Old Password" ref={e => this.oldPasswordComp = e}
                                onKeyPress={(e) => {
                                    var code = (e.keyCode ? e.keyCode : e.which)
                                    if (code === 13) {                         
                                        e.preventDefault()
                                        this.newPasswordComp.focus()
                                    }
                                }}
                                onChange={(e) => {
                                    this.resetErrorMessage()
                                }} />
                            <span className="fa fa-lock form-control-feedback"></span>
                        </div>

                        <div className="form-group has-feedback">
                            <input type="password" className="form-control"
                                placeholder="Enter New Password" ref={e => this.newPasswordComp = e}
                                onKeyPress={(e) => {
                                    var code = (e.keyCode ? e.keyCode : e.which)
                                    if (code === 13) {                         
                                        e.preventDefault()
                                        this.retypedPasswordComp.focus()
                                    }
                                }}
                                onChange={(e) => {
                                    this.resetErrorMessage()
                                }} />
                            <span className="fa fa-lock form-control-feedback"></span>
                        </div>

                        <div className="form-group has-feedback">
                            <input type="password" className="form-control"
                                placeholder="Retype Password" ref={e => this.retypedPasswordComp = e}
                                onKeyPress={(e) => {
                                    var code = (e.keyCode ? e.keyCode : e.which)
                                    if (code === 13) {                         
                                        e.preventDefault()
                                        this.resetPasswordCall()
                                    }
                                }}
                                onChange={(e) => {
                                    this.resetErrorMessage()
                                }} />
                            <span className="fa fa-sign-in form-control-feedback"></span>
                        </div>

                        <div className="row" style={{ marginTop: "40px" }}>
                            <div className="col-xs-12">
                                <div
                                    className="form-group has-error reset-error-text"
                                    style={{ display: this.state.errorVisibility }}>
                                    <label className="control-label" style={{ fontSize: "14px", fontWeight: 520 }} >
                                        {this.state.errorMessage}
                                    </label>
                                </div>
                                <button className="btn btn-primary btn-block btn-flat submit-button"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.resetPasswordCall()
                                    }}>
                                    Reset Password
                            </button>
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
            </div>
            </section>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(withRouter(PasswordReset))


// WEBPACK FOOTER //
// ./src/modules/ResetPassword/Components/PasswordReset.js